var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#ffffff",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1365,
    height: 663,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1365 663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(682.5,331.5) scale(1,1) translate(-682.5,-331.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.9130443547003342",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b65c6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7061d6",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9130443547003342)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 543.5348882920135Q 136.5 653.5601693553391  273 633.7383249800907T 546 629.5172794415159T 819 570.6455376806264T 1092 641.8097480302147T 1365 629.836726806579L 1365 0 Z;M0 0L 0 627.1815954773905Q 136.5 664.9317993656438  273 637.7159452981883T 546 534.0120213015153T 819 600.6167177326913T 1092 592.3677961925232T 1365 562.9605835185419L 1365 0 Z;M0 0L 0 616.0191597588235Q 136.5 548.5601594207079  273 527.2193009997187T 546 580.1210354845955T 819 543.6944499867888T 1092 624.3086110317332T 1365 600.5859502447307L 1365 0 Z;M0 0L 0 543.5348882920135Q 136.5 653.5601693553391  273 633.7383249800907T 546 629.5172794415159T 819 570.6455376806264T 1092 641.8097480302147T 1365 629.836726806579L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9130443547003342)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-3.3333333333333335s",
    values: "M0 0L 0 560.4440109240271Q 136.5 619.0155609496322  273 585.4898866369599T 546 611.8120863553917T 819 579.8362364042125T 1092 524.4309005455715T 1365 536.3220163462107L 1365 0 Z;M0 0L 0 545.8745062470318Q 136.5 562.6199998076671  273 540.9316439336279T 546 525.4349248913953T 819 634.3913270384003T 1092 559.0115103910056T 1365 569.9681504695756L 1365 0 Z;M0 0L 0 553.544231800617Q 136.5 585.461108671909  273 551.8845074679746T 546 551.3282123690371T 819 576.4028394025029T 1092 584.743701026986T 1365 632.6076692165251L 1365 0 Z;M0 0L 0 560.4440109240271Q 136.5 619.0155609496322  273 585.4898866369599T 546 611.8120863553917T 819 579.8362364042125T 1092 524.4309005455715T 1365 536.3220163462107L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.9130443547003342)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-6.666666666666667s",
    values: "M0 0L 0 648.4024672833236Q 136.5 587.7700267499757  273 557.438790480536T 546 550.1090738180262T 819 636.6691740373543T 1092 634.5879876768478T 1365 530.4405646218688L 1365 0 Z;M0 0L 0 578.6865261448941Q 136.5 615.3221793285937  273 565.633555952585T 546 620.4511366834757T 819 588.4742058030715T 1092 577.1069639186418T 1365 623.9433602858666L 1365 0 Z;M0 0L 0 574.1844051427214Q 136.5 627.9945308416509  273 592.7903860455067T 546 605.6893190115136T 819 611.7392198194827T 1092 571.7280571452878T 1365 561.0457900643353L 1365 0 Z;M0 0L 0 648.4024672833236Q 136.5 587.7700267499757  273 557.438790480536T 546 550.1090738180262T 819 636.6691740373543T 1092 634.5879876768478T 1365 530.4405646218688L 1365 0 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.3c310352a6d940cab9637aea9d76b715.svg";
export { ForwardRef as ReactComponent };